import { render, staticRenderFns } from "./DemoSettings.vue?vue&type=template&id=bff4a51a"
import script from "./DemoSettings.vue?vue&type=script&lang=js"
export * from "./DemoSettings.vue?vue&type=script&lang=js"
import style0 from "./DemoSettings.vue?vue&type=style&index=0&id=bff4a51a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports